export default __webpack_public_path__ + "static/SuisseIntl-Regular-WebS-7328f724fa58bdc7a3a70bb9430e77f0.woff2";